export default __webpack_public_path__ + "static/media/Quicksand-Bold.4c3d2317.ttf";